module.exports = __webpack_public_path__ + "img/banner2.a0d36ba0.jpg";